<div class="fluid-container p-3 coupon-recharge-wrapper">
  <!-- Top Site Context Banner -->

  <!-- Main Recharge Card -->
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8 col-xl-6">
      <div class="card recharge-card shadow-sm">
        <div class="card-header filter d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-2">
            <div class="header-icon-pill">
              <i class="fa fa-bolt text-primary fs-5"></i>
            </div>
            <div>
              <span class="filterspan d-block">Coupon Recharge</span>
              <small class="text-muted d-block" style="font-size: 0.775rem;">Recharge using coupon serial number</small>
            </div>
          </div>

        </div>

        <div class="card-body p-4">
          <form (ngSubmit)="onRechargeSubmit()" #rechargeForm="ngForm" novalidate>
            <!-- Site Info (Read-only reference showing site name) -->
            <div class="mb-3">
              <label class="form-label fw-semibold">
                <i class="fa fa-map-marker text-muted me-1"></i> Selected Site
              </label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fa fa-building"></i>
                </span>
                <input
                  type="text"
                  class="form-control"
                  [value]="siteName || (siteid ? 'Selected Site' : 'No site selected')"
                  readonly
                  disabled
                />
              </div>
            </div>

            <div class="mb-3">
              <label for="location_id" class="form-label fw-semibold">
                <i class="fa fa-map-marker text-muted me-1"></i> Location
                <span class="text-danger">*</span>
              </label>
              <select
                id="location_id"
                name="location_id"
                class="form-select form-select-lg"
                [(ngModel)]="locationid"
                required
                [disabled]="isRecharging || !siteid || locations.length === 0"
              >
                <option value="" disabled>{{ siteid ? 'Select location' : 'Select a site first' }}</option>
                <option *ngFor="let location of locations" [value]="location.id ?? location.location_id ?? location._id">
                  {{ location.location_no ?? location.name ?? location.location_name }}
                </option>
              </select>
            </div>

            <!-- Serial Number Input -->
            <div class="mb-4">
              <label for="serial_number" class="form-label fw-semibold">
                <i class="fa fa-barcode text-muted me-1"></i> Serial Number
                <span class="text-danger">*</span>
              </label>
              <div class="input-group input-group-lg">
                <span class="input-group-text">
                  <i class="fa fa-ticket"></i>
                </span>
                <input
                  type="text"
                  id="serial_number"
                  name="serial_number"
                  class="form-control"
                  placeholder="Enter serial number"
                  [(ngModel)]="serialNumber"
                  required
                  autocomplete="off"
                  [disabled]="isRecharging || !siteid || !locationid"
                />
                <button
                  *ngIf="serialNumber"
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="onReset()"
                  [disabled]="isRecharging"
                  title="Clear input"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="form-text mt-1 text-muted">
                Provide the unique coupon serial number to process recharge.
              </div>
            </div>

            <!-- Submit & Action Buttons -->
            <div class="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
              <button
                type="button"
                class="btn btn-outline-secondary px-3 py-2"
                (click)="onReset()"
                [disabled]="isRecharging || !serialNumber"
              >
                <i class="fa fa-eraser me-1"></i> Clear
              </button>
              <button
                type="submit"
                class="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                [disabled]="isRecharging || !siteid || !locationid || !serialNumber.trim()"
              >
                <span *ngIf="isRecharging" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <i *ngIf="!isRecharging" class="fa fa-bolt"></i>
                <span>{{ isRecharging ? 'Recharging...' : 'Recharge' }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
